import { Options } from '../options.interface';
import { OPS_EVENT_API_CONFIG } from './ops-event-api.config';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EventType, OpsEvent, OpsEventLight, toOpsEvent, toOpsEventLight } from '@wizbii/utils/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class EventWebservice {
  readonly #http = inject(HttpClient);
  readonly #opsEventApiApiConfig = inject(OPS_EVENT_API_CONFIG);

  readonly #baseUrl = this.#opsEventApiApiConfig.baseUrl;

  getEventById(eventId: string, options?: Options): Observable<OpsEvent> {
    return this.#http
      .get<Record<string, unknown>>(`${this.#baseUrl}/v2/event/${eventId}`, options)
      .pipe(map(toOpsEvent));
  }

  getEventDescription(eventId: string, options?: Options): Observable<string> {
    return this.#http
      .get<{ description: string }>(`${this.#baseUrl}/api/event/${eventId}/preview-description`, options)
      .pipe(map((payload) => payload.description));
  }

  getAllEvents(options?: Options): Observable<OpsEventLight[]> {
    return this.#http
      .get<Record<string, unknown>[]>(`${this.#baseUrl}/api/events/list/incoming-light-illustrated`, options)
      .pipe(map((response) => response.map(toOpsEventLight)));
  }

  getEventTypes(options?: Options): Observable<EventType[]> {
    return this.#http.get<EventType[]>(`${this.#baseUrl}/v2/event-types`, options);
  }
}
